import { RAW, ENRICHED } from 'admin/pages/RecordEdit_v2/common/constants'

export const isDisabled = (
  formItemIsRaw: boolean,
  dataView: string,
  showRaw: boolean
): boolean => {
  if (formItemIsRaw && showRaw && dataView === ENRICHED) {
    return true
  }
  return false
}

export const isHidden = (
  formItemIsRaw: boolean,
  dataView: string,
  showRaw: boolean
): boolean => {
  if (
    (formItemIsRaw && dataView === RAW) ||
    (!formItemIsRaw && dataView === ENRICHED) ||
    (formItemIsRaw && showRaw && dataView === ENRICHED)
  ) {
    return false
  }
  return true
}
